module.exports = __webpack_public_path__ + "4ca88607e6d169fa92971c42c870407a.svg";